import { useMemo } from 'react';

export function useSelectedVariantProduct({ product, selectedVariant }) {
  return useMemo(() => {
    if (selectedVariant && selectedVariant.extraInfo) {
      return {
        ...product,
        skuId: selectedVariant.extraInfo,
        offeringId: selectedVariant.extraInfo,
        mediaUrls: selectedVariant.mediaUrls || product.mediaUrls,
        prices: selectedVariant.sizes?.[0]?.prices || product.prices,
        measurements: product.measurements,
      };
    }
    return product;
  }, [product, selectedVariant]);
}
